export const useModalStore = defineStore({
  id: 'modalStore',
  state: () => ({
    modal: '',
  }),
})
